var video_containers = document.getElementsByClassName('go_video_container');

for (i=0; i<video_containers.length; i++) {
	let container = video_containers[i];
	let button = document.createElement('button');
	button.innerText = '▶';
	button.addEventListener(
		'click', (e) => showVideo(container.id)
	);
	container.append(button);
	
	let modal = document.createElement('div');
	modal.classList.add('go_video_modal');
	modal.id = 'go_video_modal_'+container.id;
	
	let modal_buttons = document.createElement('div');
	modal_buttons.classList.add('go_video_modal_buttons');
	modal_buttons.id = 'go_video_modal_buttons_'+container.id;
	
	let close_button = document.createElement('button');
	close_button.innerText = 'X';
	close_button.addEventListener(
		'click', (e) => hideVideo(container.id)
	);
	modal_buttons.append(close_button);
	
	let modal_content = document.createElement('div');
	modal_content.classList.add('go_video_modal_content');
	modal_content.id = 'go_video_modal_content_'+container.id;
	
	modal.append(modal_buttons);
	modal.append(modal_content);
	
	document.body.append(modal);
}

function showVideo(video_id) {
    console.log("showVideo");
	let modal = document.getElementById('go_video_modal_'+video_id);
    console.log("MOdal: ", modal);
	let modal_content = document.getElementById('go_video_modal_content_'+video_id);
	
	if (video_id.length < 13) {
		var content = document.createElement('iframe');
		content.src = 'https://www.youtube.com/embed/'+video_id+'?autoplay=1';
		content.setAttribute('frameborder',0);
		content.setAttribute('allowfullscreen','');
	} else {
		var content = document.createElement('video');
		content.setAttribute('controls','');
		content.setAttribute('autoplay','');
		let source = document.createElement('source');
		source.src = 'https://wwww.geschenke-online.de/media/video/'+video_id;
		content.append(source);
	}
	
	modal_content.append(content);
    console.log("Content: ", content);
	modal.style.display = 'block';
}
function hideVideo(video_id) {
	let modal = document.getElementById('go_video_modal_'+video_id);
	let modal_content = document.getElementById('go_video_modal_content_'+video_id);
	modal.style.display = 'none';
	modal_content.innerHTML = '';
}
